








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserPointsRecordList, ExportUserPointsRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { PointsRecordStatusFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class UserPointsRecordList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
    finishTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '关联单号', param: 'recordNo' },
    { title: '途径类型', param: 'wayType', type: 'select', selectData: constant.FrozenPointsWayType },
    { title: '状态', param: 'status', type: 'select', selectData: constant.PointsRecordStatus },
    { title: '完成时间', param: 'finishTimeDaterange', type: 'daterange' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'userId', width: 100 },
    { title: '用户名称', param: 'userName', width: 120 },
    { title: '手机号', param: 'mobilePhone', width: 120 },
    { title: '变动数量', param: 'qty' },
    { title: '应变动', param: 'shouldQty' },
    { title: '关联单号', param: 'recordNo', width: 200, overflow: true },
    { title: '途径类型', param: 'wayTypeName', width: 200, overflow: true },
    { title: '状态', param: 'status', formatter: PointsRecordStatusFormat, width: 90 },
    { title: '变动前余额', param: 'beforeBalance' },
    { title: '变动后余额', param: 'balance' },
    { title: '完成时间', width: 160, param: 'finishTime', formatter: DateFormat },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  public activated() {
    this.applyRouteQuery()
    this.loadData()
  }

  public async created() {
    this.applyRouteQuery()
    this.loadData()
  }

  private applyRouteQuery() {
    const q = this.$route.query
    if (q.finishTime) {
      this.queryParam.finishTimeDaterange = [q.finishTime + ' 00:00:00', q.finishTime + ' 23:59:59']
    }
    if (q.wayType) {
      this.queryParam.wayType = Number(q.wayType)
    }
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserPointsRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param = this.buildExportParam()
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  private buildExportParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    if (param.finishTimeDaterange && param.finishTimeDaterange.length > 0) {
      param.finishTimes = DateFormat(param.finishTimeDaterange[0]) + ',' + DateFormat(param.finishTimeDaterange[1])
    }
    delete param.createTimeDaterange
    delete param.finishTimeDaterange
    delete param.startRow
    delete param.limit
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private exportHandle() {
    const loading = this.$loading({
      lock: true,
      text: '正在导出',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    const param = this.buildExportParam()
    ExportUserPointsRecordList(param, '积分明细.xlsx')
      .then(() => loading.close())
      .catch(() => loading.close())
  }
}
